import { render } from "./RegisterModal.vue?vue&type=template&id=097705de&scoped=true&ts=true"
import script from "./RegisterModal.vue?vue&type=script&lang=ts"
export * from "./RegisterModal.vue?vue&type=script&lang=ts"

import "./RegisterModal.vue?vue&type=style&index=0&id=097705de&scoped=true&lang=css"

import exportComponent from "/app/purple__bee/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-097705de"]])

export default __exports__